import React from 'react';

export const MidPageCTA = () => {
  return (
    <section className="relative py-14 md:py-18 overflow-hidden">
      {/* Soft gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-slate-50/50 to-white" />
      
      {/* Purple glow behind button */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[250px] bg-gradient-to-t from-turret-purple/[0.15] via-violet-400/[0.1] to-transparent rounded-full blur-2xl" />

      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        {/* Compact heading */}
        <h3 className="text-2xl md:text-3xl font-semibold text-neutral-800 mb-3 tracking-tight leading-tight">
          See what's really happening
          <span className="text-turret-purple"> in your AI conversations</span>
        </h3>
        
        <p className="text-neutral-500 text-base md:text-lg mb-7">
          Get full access for 14 days. Cancel anytime.
        </p>

        {/* Premium button */}
        <a
          href="https://dashboard.useturret.com"
          className="group inline-flex items-center gap-2.5 px-8 py-4 rounded-full font-medium text-base text-white transition-all duration-300 ease-out
            bg-neutral-900 
            shadow-[0_2px_16px_-4px_rgba(0,0,0,0.25)]
            hover:bg-turret-purple hover:shadow-[0_4px_24px_-4px_rgba(124,58,237,0.5)]
            hover:-translate-y-0.5
            active:translate-y-0"
        >
          <span>Start free 14-day trial</span>
          <svg 
            className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all duration-300" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </a>

        {/* Trust indicators */}
        <div className="mt-5 flex items-center justify-center gap-4 text-neutral-400 text-xs">
          <span className="flex items-center gap-1.5">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Full feature access
          </span>
          <span className="w-1 h-1 rounded-full bg-neutral-300" />
          <span>Cancel anytime</span>
          <span className="w-1 h-1 rounded-full bg-neutral-300" />
          <span>5-min setup</span>
        </div>
      </div>
    </section>
  );
};
